// src/components/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ reverse = false }) => {
  const token = localStorage.getItem("token");
  
  if (reverse) {
    // For routes that should NOT be accessible when authenticated (like login)
    return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
  }
  
  // For routes that require authentication
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;